{
  "brand": "NAPAICP 競賽平台",
  "headerBrand": "NAPAICP 競賽平台",
  "siteUrl": "https://aicp.ntpu.ai/",
  "securityContactEmail": "aintpu@gmail.com",
  "breadcrumb": "麵包屑",
  "competition": {
    "officialWebsite": "官方競賽網站 ↗",
    "officialWebsiteAriaLabel": "在新分頁開啟 {{name}} 官方競賽網站",
    "logoAlt": "{{name}} Logo"
  },
  "lastUpdated": "最後更新",
  "calloutNote": "注意",
  "files": {
    "preview": "線上預覽",
    "download": "下載",
    "downloadFailed": "無法取得下載連結。",
    "selectFile": "選擇要預覽的檔案",
    "previewError": "無法載入作品預覽",
    "previewErrorReasons": "可能原因：連結已過期、網路連線問題。",
    "retryPreview": "重新載入預覽",
    "retryDownloadLink": "重新取得下載連結",
    "previewFatalError": "請重新整理頁面。"
  },
  "state": {
    "loading": "載入中…",
    "checking": "檢查中…",
    "error": "發生錯誤。",
    "empty": "目前沒有內容。",
    "notSignedIn": "尚未登入",
    "signedIn": "已登入"
  },
  "action": {
    "signOut": "登出",
    "signIn": "登入",
    "signingIn": "登入中…",
    "cancel": "取消",
    "save": "儲存",
    "saving": "儲存中…",
    "delete": "刪除",
    "edit": "編輯",
    "create": "新增",
    "select": "請選擇…",
    "back": "返回",
    "close": "關閉",
    "confirm": "確認",
    "retry": "重試",
    "skipToContent": "跳至主要內容"
  },
  "placeholder": {
    "title": "尚未提供",
    "description": "此畫面為預留頁面，目前不會讀取或寫入競賽資料。"
  },
  "footer": {
    "tagline": "管理團隊、作品繳交、評審與結果的多競賽平台",
    "poweredBy": "Powered by NAPAI × NTPU AI4X",
    "copyright": "© {{year}} <brandLink>NAPAICP 競賽平台</brandLink>"
  },
  "status": {
    "title": "平台狀態",
    "description": "API 與目前登入狀態的即時檢查結果。",
    "api": {
      "title": "API",
      "description": "即時檢查後端服務與其綁定資源。",
      "unreachable": "API 無法連線",
      "reachable": "可連線",
      "failed": "失敗"
    },
    "session": {
      "title": "登入狀態",
      "description": "儲存於 HttpOnly cookie，任何指令碼皆無法讀取其內容。",
      "globalRole": "平台角色"
    },
    "competition": {
      "draft": "草稿",
      "published": "已發布",
      "registration_open": "報名開放中",
      "submission_open": "作品繳交開放中",
      "judging": "評審中",
      "completed": "已結束",
      "archived": "已封存"
    },
    "formVersion": {
      "draft": "草稿",
      "published": "已發布",
      "superseded": "已被取代"
    },
    "resultRun": {
      "draft": "草稿",
      "calculated": "已計算",
      "locked": "已鎖定",
      "published": "已發布"
    },
    "submission": {
      "draft": "草稿",
      "ready": "已準備",
      "submitted": "已提交",
      "locked": "已鎖定",
      "withdrawn": "已撤回",
      "disqualified": "已取消資格"
    },
    "file": {
      "pending": "上傳中",
      "completed": "已完成",
      "aborted": "已中止"
    },
    "assignment": {
      "active": "進行中",
      "completed": "已完成",
      "cancelled": "已取消"
    },
    "competitionRole": {
      "competition_admin": "競賽管理員",
      "staff": "工作人員",
      "student": "學生",
      "teacher": "指導老師",
      "judge": "評審",
      "observer": "觀察者"
    },
    "platformRole": {
      "user": "一般使用者",
      "super_admin": "系統管理員"
    },
    "teamRole": {
      "leader": "隊長",
      "member": "隊員",
      "teacher": "指導老師"
    },
    "team": {
      "active": "進行中",
      "disbanded": "已解散"
    },
    "user": {
      "active": "啟用",
      "suspended": "已停權",
      "deleted": "已刪除"
    },
    "competitionRequest": {
      "draft": "草稿",
      "submitted": "待審核",
      "under_review": "審核中",
      "changes_requested": "等待申請人補件",
      "approved": "已核准",
      "rejected": "已拒絕",
      "cancelled": "已撤回"
    }
  },
  "notFound": {
    "title": "找不到頁面",
    "description": "此網址沒有對應的內容。",
    "back": "返回首頁"
  },
  "devSignIn": {
    "title": "開發用登入",
    "description": "僅限本機環境，使用測試帳號登入。",
    "email": "電子郵件",
    "password": "密碼",
    "failed": "登入失敗。"
  },
  "passwordVisibility": {
    "show": "顯示密碼",
    "hide": "隱藏密碼"
  },
  "googleSignIn": {
    "action": "使用 Google 帳號登入"
  },
  "register": {
    "title": "建立帳號",
    "description": "使用電子郵件與密碼註冊。",
    "displayName": "顯示名稱",
    "passwordHint": "至少需要 10 個字元。",
    "action": "建立帳號",
    "failed": "註冊失敗。",
    "checkEmail": "請至您的電子郵件信箱查看驗證連結，以完成帳號建立。",
    "haveAccount": "已經有帳號了嗎？"
  },
  "loginPage": {
    "title": "登入",
    "description": "使用您的帳號繼續。",
    "orSeparator": "或",
    "noAccount": "還沒有帳號？",
    "needAccount": "建立帳號",
    "forgotPassword": "忘記密碼？",
    "devTools": "開發環境登入"
  },
  "forgotPassword": {
    "title": "忘記密碼",
    "description": "我們將寄送重設密碼連結至您的信箱。",
    "action": "寄送重設連結",
    "checkEmail": "若該電子郵件對應帳號存在，重設連結即將寄出。"
  },
  "resetPassword": {
    "title": "重設密碼",
    "description": "為您的帳號設定新密碼。",
    "newPassword": "新密碼",
    "passwordHint": "至少需要 10 個字元。",
    "action": "重設密碼",
    "failed": "無法重設您的密碼。",
    "success": "您的密碼已重設完成，現在可以登入。",
    "invalidLink": "此密碼重設連結無效或已過期。"
  },
  "forcedPasswordChange": {
    "title": "請設定您的新密碼",
    "description": "您這次是以一次性臨時密碼登入。請先設定自己的密碼才能繼續使用系統，完成前無法使用其他功能。",
    "newPassword": "新密碼",
    "passwordHint": "至少需要 10 個字元。",
    "action": "設定密碼並繼續",
    "failed": "無法設定您的新密碼。",
    "success": "密碼已設定完成，正在載入系統…"
  },
  "bootstrapPage": {
    "title": "平台初始化",
    "description": "使用部署端的 Bootstrap Credential 建立平台第一位 Super Admin。",
    "signInFirst": "請先以已驗證 Email 且啟用中的帳號登入，再進行平台初始化。",
    "goToSignIn": "前往登入",
    "oneTimeNoticeTitle": "一次性平台初始化",
    "oneTimeNoticeBody": "這是部署負責人執行的一次性操作。建立帳號不會自動使任何人成為 Super Admin，此表單是平台第一位 Super Admin 產生的唯一途徑，且一旦平台已有 Super Admin，此流程即失效。",
    "credentialLabel": "Bootstrap Credential",
    "submitAction": "初始化平台",
    "submitting": "初始化中...",
    "failed": "目前無法進行平台初始化。"
  },
  "relativeTime": {
    "justNow": "剛剛",
    "minutesAgo": "{{count}} 分鐘前",
    "todayAt": "今天 {{time}}",
    "yesterdayAt": "昨天 {{time}}",
    "dateAt": "{{month}}月{{day}}日 {{time}}"
  },
  "apiError": {
    "UNAUTHENTICATED": "需要先登入。",
    "FORBIDDEN": "您沒有權限執行此操作。",
    "COMPETITION_NOT_FOUND": "找不到此競賽。",
    "TEAM_NOT_FOUND": "找不到此隊伍。",
    "SUBMISSION_NOT_FOUND": "找不到此作品繳交紀錄。",
    "SUBMISSION_DEADLINE_PASSED": "已超過繳交截止時間。",
    "SUBMISSION_ALREADY_LOCKED": "此作品繳交已鎖定。",
    "FILE_TOO_LARGE": "上傳的檔案過大。",
    "FILE_TYPE_NOT_ALLOWED": "不允許此檔案類型。",
    "JUDGE_NOT_ASSIGNED": "您並未被指派評審此作品。",
    "SCORE_ALREADY_LOCKED": "此評分已鎖定，無法修改。",
    "CONFLICT_OF_INTEREST": "已申報的利益衝突使此操作無法進行。",
    "VALIDATION_ERROR": "送出的內容有誤。",
    "RATE_LIMITED": "請求過於頻繁，請稍後再試。",
    "NOT_FOUND": "找不到該資源。",
    "INTERNAL_ERROR": "發生未預期的錯誤。",
    "BOOTSTRAP_UNAVAILABLE": "目前無法進行平台初始化。",
    "USER_NOT_FOUND": "找不到此使用者。",
    "LAST_SUPER_ADMIN_PROTECTED": "此帳號是平台目前唯一的啟用中平台管理員，無法移除或停用。",
    "USER_NOT_ACTIVE": "此操作需要帳號為啟用狀態。",
    "EVENT_BOOKING_CONFLICT": "無法完成接駁車預約。",
    "ROLE_NOT_FOUND": "找不到此角色授權紀錄。",
    "LAST_COMPETITION_ADMIN_PROTECTED": "此競賽必須保留至少一位競賽管理員，無法撤銷這個授權。",
    "PASSWORD_CHANGE_REQUIRED": "請先設定新密碼才能繼續。",
    "JUDGE_INVITATION_NOT_FOUND": "此邀請無效、已過期或已被使用。",
    "COMPETITION_REQUEST_NOT_FOUND": "找不到此競賽申請。",
    "COMPETITION_REQUEST_NOT_APPROVABLE": "此申請目前的狀態不允許此操作。",
    "COMPETITION_REQUEST_APPROVAL_IN_PROGRESS": "此申請正在核准處理中，請稍後再試。",
    "SESSION_NOT_FOUND": "找不到此登入工作階段。",
    "LOCAL_PASSWORD_NOT_AVAILABLE": "此帳號由外部身分提供者管理，沒有可變更的本地密碼。",
    "ELIGIBILITY_NOT_FOUND": "找不到資格驗證紀錄。",
    "ELIGIBILITY_PROOF_NOT_FOUND": "找不到此在學證明檔案。",
    "ELIGIBILITY_PROOF_NOT_CURRENT": "此檔案已不是目前有效的在學證明。",
    "CATEGORY_CAPACITY_FULL": "此組別的隊伍名額已滿，請選擇其他組別或聯絡主辦方。",
    "ROUND_SCORING_MODE_CONFLICT": "此輪次的評分輸入方式不允許這個操作。"
  }
}
